import React, { useEffect, useRef, useState } from 'react';
import { Button, Divider, Dropdown, Menu, Message, Space, Switch } from '@bedrock/components';
import { Plus, SignIn, ChevronDown } from '@bedrock/icons-react';
import { ProTablePlusForm } from '@mpc/common/src/components';
import useDesignatedExpertColumns from '../../cells/useDesignatedExpertColumns';
// import StarSelectDrawer from '../../StarSelectDrawer';
import { useImportFileModal } from "#features/importFileModal";
import { FullScreenButton } from '@mpc/components';
import { ProCard, useScreenAdapterContext } from '@bedrock/eed-react';
import SupplierVisible from '#features/SupplierVisible';
import LoadingModal from '../LoadingModal';
import { demandSourceGetKolInfoUsingPost } from '#services/api';
import StarSelectDrawer from '#features/MPCDemand/StarSelectDrawer';

type ImportMode = 'overwrite' | 'append';

interface Props {
  view?: boolean;
  style?: React.CSSProperties;
  className?: string;
  handleFullChange?: (isFullscreen: boolean) => void;
  l3_category_id?: any;
  isFullscreen?: boolean;
  state?: any[];
  setState?: (value: any[]) => void;
  tableRef?: any;
}

const SplitDesignatedExpert = (props: Props) => {
  const { view, style, className, l3_category_id, isFullscreen, handleFullChange, state, setState, tableRef } = props;
  const { viewBase } = useScreenAdapterContext();
  const [checked, setChecked] = useState(!!state?.length);
  const [expanded, setExpanded] = React.useState(!!state?.length);
  const [visible, setVisible] = React.useState(false);
  const fullBtnRef = React.useRef<any>();

  const { columnsConfig, loading } = useDesignatedExpertColumns({
    view,
    changeData: setState,
    l3_category_id,
  });
  const { openImportFileModal, closeImportFileModal } = useImportFileModal({});

  const fullRef = useRef(null);

  const handleImportFile = (mode: ImportMode) => {
    openImportFileModal({
      importType: `demand_source_kol${l3_category_id}`,
      importIsMemory: false,
      showSuccessToast: false,
      uploadFinishedCallback: async (res) => {
        // 有错误时，不进行数据更新
        if (res?.data?.fail_count > 0) return;
        if (res.code === 1 && res.data?.data?.length) {
          closeImportFileModal();
          try {
            setVisible(true);
            const result = await demandSourceGetKolInfoUsingPost({
              main_platform_link: res.data?.data?.map((v: { main_platform_link: string }) => v.main_platform_link),
              content_type: l3_category_id,
            });
            const list = res.data?.data?.map((v: any) => {
              const newData = result?.data?.find((s: any) => s.origin_main_platform_link === v.main_platform_link);
              if (newData) {
                return {
                  ...v,
                  ...newData,
                  import_type: 'FROM_CONTENT',
                  add_form_not_included: true,
                };
              }
              return {
                ...v,
                import_type: 'FROM_PLAN',
                add_form_not_included: true,
              };
            });
            if (mode === 'overwrite') {
              setState(list);
              Message.success(`导入覆盖成功 ${list.length} 条数据`);
            } else {
              setState([...(state || []), ...list]);
              Message.success(`导入添加成功 ${list.length} 条数据`);
            }
          } catch (error) {
            console.log('error', error);
          } finally {
            setVisible(false);
          }
        }
      },
    });
  };

  useEffect(() => {
    if (state?.length) {
      setChecked(true);
      setExpanded(true);
    }
  }, [state])

  return (
    <div style={{ width: '100%', ...style }} className={className}>
      <div ref={fullRef} style={{padding: 0}}>
        <ProCard
          title={
            <Space size={4} onClick={(e) => e?.stopPropagation()}>
              <SupplierVisible>
                指定达人
              </SupplierVisible>
              <Divider />
              <span className='text-[var(--text-color-3)] text-[14px] font-normal mr-1'>是否有指定达人</span>
              <Switch
                labelOn="有"
                labelOff="无"
                checked={checked}
                onChange={(val) => {
                  if (!val) {
                    setState([]);
                  }
                  setExpanded(val);
                  setChecked(val);
                  if (!val && isFullscreen) {
                    fullBtnRef.current?.handleExpandScreen();
                  }
                }}
              />
            </Space>
          }
          expandable={checked}
          expanded={expanded}
          onExpandedChange={setExpanded}
          rightSlot={
            checked && <Space size={0} onClick={(e) => e?.stopPropagation()}>
              <Dropdown
                overlay={
                  <Menu
                    onClick={({ key }) => handleImportFile(key as ImportMode)}
                  >
                    <Menu.Item key="overwrite">添加覆盖导入</Menu.Item>
                    <Menu.Item key="append">新增导入</Menu.Item>
                  </Menu>
                }
              >
                <Button
                  size='small'
                  type='checked-neutral'
                  icon={<SignIn />}
                  suffixIcon={<ChevronDown className="rock-dropdown-down-arrow-icon" />}
                >
                  批量导入
                </Button>
              </Dropdown>
              <Divider />
              <FullScreenButton ref={fullBtnRef} fullRef={fullRef} handleFullChange={handleFullChange} />
            </Space>
          }
        >
          {checked && <>
            <ProTablePlusForm
              ref={tableRef}
              style={{ width: '100%' }}
              scroll={{ 'x': 'max-content', y: isFullscreen ? window.innerHeight - 180 * viewBase : 560 }}
              value={state}
              onChange={setState}
              columns={
                [
                  columnsConfig.index,
                  {
                    ...columnsConfig.profile_of_the_expert,
                    fixed: 'left' as const,
                  },
                  columnsConfig.main_platform,
                  columnsConfig.public_order,
                  columnsConfig.main_platform_quote_item,
                  columnsConfig.number_of_fans,
                  columnsConfig.historical_cooperation,
                  columnsConfig.platform_price,
                  columnsConfig.CPM,
                  {
                    title: '操作',
                    dataIndex: 'actions',
                    width: 60 * viewBase,
                    fixed: 'right',
                    render: (v: any, record: any, index: number) => {
                      return <Button type="link" danger onClick={() => setState(state.filter((s, i) => i !== index))}>删除</Button>
                    }
                  },
                ]
              }
              isShowLoading={loading}
              virtual={{ maxRows: 0, useAntd: false, itemHeight: 123 }}
              verticalBorder
            />
            <Button
              className='mt-[8px]'
              size='medium'
              type='checked'
              icon={<Plus />}
              onClick={() => {
                StarSelectDrawer.show({
                  l3_category_id,
                  onOk: ({
                    contentData,
                    planData,
                  }) => {
                    setState([...(state || []), ...contentData, ...planData]);
                  }
                })
              }}
            >
              添加达人
            </Button>
          </>}
        </ProCard>
        <LoadingModal visible={visible} />
      </div>
    </div>
  )
}

export default SplitDesignatedExpert
